/* global fetch */

import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";

import { BlankStory } from "../story-templates/blank.js";
import { PhotoStory } from "../story-templates/photo.js";
import { LiveBlogStory } from "../story-templates/live-blog.js";
import { VisualStory } from "../story-templates/visual-story";
import { VideoStory } from "../story-templates/video.js";
import { HeroWideTextStory } from "../story-templates/hero-wide-text.js";
import { InfiniteStoryBase } from "@quintype/components";
import { getInfiniteScrollApi } from "../../utils";

function getBlankStoryTemplate(story, config, preview) {
  const textStory = get(config, ["theme-attributes", "text-story"], "default");
  if (textStory === "hero-wide") {
    return <HeroWideTextStory story={story} config={config} preview={preview} />;
  }
  return <BlankStory story={story} config={config} preview={preview} />;
}

export function StoryPageContent(data, config) {
  const { story, preview = false } = data;

  switch (story["story-template"]) {
    case "live-blog":
      return <LiveBlogStory story={story} config={config} preview={preview} />;
    case "video":
      return <VideoStory story={story} config={config} preview={preview} />;
    case "photo":
      return <PhotoStory story={story} config={config} preview={preview} />;
    case "visual-story":
      return <VisualStory story={story} config={config} />;
    case "news-elsewhere":
      return null;
    default:
      return getBlankStoryTemplate(story, config, preview);
  }
}

function storyPageLoadItems(pageNumber, story = {}, config = {}) {
  const infiniteScrollType = get(config, ["theme-attributes", "infinite-scroll"], "");
  const sectionId = get(story, ["sections", 0, "id"], null);
  const params = {
    pageNumber,
    sectionId
  };
  let infiniteScrollApi = getInfiniteScrollApi(infiniteScrollType, params);

  return fetch(infiniteScrollApi)
    .then(response => {
      return response.json();
    })
    .then(response => {
      const items = response.stories || response.items || [];
      return items.map(item => ({ story: item.story || item }));
    })
    .catch(err => {
      console.error("Error in retrieving infinite scroll stories :", err);
      return [];
    });
}

export class StoryPage extends React.Component {
  doAnalytics(story) {
    const { registerPageView } = require("@quintype/framework/client/analytics");
    registerPageView({ type: "story-page", story: story }, `/${story.slug}`);
  }

  render() {
    const infiniteScrollType = get(this.props.config, ["theme-attributes", "infinite-scroll"], "");
    if (this.props.preview || infiniteScrollType === "disabled") {
      return StoryPageContent(this.props.data, this.props.config);
    }

    return (
      <div className="infinite-wrapper">
        <InfiniteStoryBase
          {...this.props}
          render={storyProps => StoryPageContent(storyProps, this.props.config)}
          loadItems={storyPageLoadItems}
          onItemFocus={item => console.log(`Story In View: ${item.story.headline}`)}
          onInitialItemFocus={item => this.doAnalytics(item.story)}
        />
      </div>
    );
  }
}

StoryPageContent.propTypes = {
  config: PropTypes.object,
  data: PropTypes.shape({
    story: PropTypes.object,
    relatedStories: PropTypes.array,
    index: PropTypes.number,
    preview: PropTypes.bool
  })
};

StoryPage.propTypes = {
  preview: PropTypes.bool,
  config: PropTypes.object,
  data: PropTypes.shape({
    story: PropTypes.object,
    relatedStories: PropTypes.array,
    index: PropTypes.number,
    preview: PropTypes.bool
  })
};
